import { isEmpty } from 'underscore';

export const getUrlOptionsDetails = (i18n, urlOptions) => {
  const details = [];
  if (urlOptions.TrackingUrlTemplate) {
    details.push(`${i18n.getString(_TL_('Tracking template'))}: ${urlOptions.TrackingUrlTemplate}`);
  }
  if (urlOptions.FinalUrlSuffix) {
    details.push(`${i18n.getString(_TL_('Final URL suffix'))}: ${urlOptions.FinalUrlSuffix}`);
  }
  if (urlOptions.UrlCustomParameters && urlOptions.UrlCustomParameters.length > 0) {
    const params = urlOptions.UrlCustomParameters
      .filter(({ Key }) => Key)
      .map(({ Key, Value }) => `{_${Key}} = ${Value}`)
      .join('; ');

    if (params) {
      details.push(`${i18n.getString(_TL_('Custom parameters'))}: ${params}`);
    }
  }

  if (isEmpty(details)) {
    return i18n.getString(_TL_('No settings applied'));
  }

  return details.join(', ');
};
